import * as constant from './constants';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';


function encryptUsingAES256() {
  const keyWords = CryptoJS.enc.Utf8.parse(constant.encryKey);
  const iv = CryptoJS.lib.WordArray.create(new Uint8Array(16));
  const encrypted = CryptoJS.AES.encrypt(constant.encryText, keyWords, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

export function httpPostFetch(apiUrl, body, authToken) {
  return new Promise((resolve, reject) => {
    try {
      const axiosInstance = axios.create({
        timeout: 30000,

        headers: authToken
          ? {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
            'Accept': '*/*',
            'Auth_Key': encryptUsingAES256(),
          }
          : {
            'Content-Type': 'application/json',
            'Accept': '*/*',
            'Auth_Key': encryptUsingAES256(),
          }
      });
      axiosInstance
        .post(constant.rootUrl + apiUrl, body)
        .then((res) => {

          resolve(res.data);
        })
        .catch((e) => {
          reject('Something went wrong');
          if (e?.response?.status === 401) {
            let navigate = useNavigate();
            navigate('/');
          }
        });
    } catch (error) {
      reject(error);
      if (error?.response?.status === 401) {
        let navigate = useNavigate();
        navigate('/');
      }
    }
  });
}

export function httpGetFetch(apiUrl, authToken) {
  return new Promise((resolve, reject) => {
    try {
      const axiosInstance = axios.create({
        timeout: 5000,
        headers: authToken
          ? {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
            'Accept': '*/*',
            'Auth_Key': encryptUsingAES256(),

          }
          : {
            'Content-Type': 'application/json',
            'Accept': '*/*',
            'Auth_Key': encryptUsingAES256(),

          },
      });
      axiosInstance
        .get(constant.rootUrl + apiUrl)
        .then((res) => {

          resolve(res.data);
        })
        .catch((e) => {
          reject('Something went wrong');
          if (e?.response?.status === 401) {
            let navigate = useNavigate();
            navigate('/');

          }
        });
    } catch (error) {
      reject(error);
      if (error?.response?.status === 401) {
        let navigate = useNavigate();
        navigate('/');
      }
    }
  });
}
export function httpGetFetchForIfsc(apiUrl, authToken) {
  return new Promise((resolve, reject) => {
    try {
      const axiosInstance = axios.create({
        timeout: 5000,
        headers: authToken
          ? {
            'Content-Type': 'application/json',
            'Accept': '*/*',
            'Authorization': `Bearer ${authToken}`
          }
          : {
            'Content-Type': 'application/json',
            'Accept': '*/*'
          },
      });
      axiosInstance
        .get('https://ifsc.razorpay.com/' + apiUrl)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject('Something went wrong');
          if (e?.response?.status === 401) {
            let navigate = useNavigate();
            navigate('/');
          }
        });
    } catch (error) {
      reject(error);
      if (error?.response?.status === 401) {
        let navigate = useNavigate();
        navigate('/');
      }
    }
  });
}

export function httpGetFetchForPincode(apiUrl, authToken) {
  return new Promise((resolve, reject) => {
    try {
      const axiosInstance = axios.create({
        timeout: 5000,
        headers: authToken
          ? {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
            'Accept': '*/*'

          }
          : {
            'Content-Type': 'application/json',
            'Accept': '*/*'
          },
      });
      axiosInstance
        .get('https://api.postalpincode.in/pincode/' + apiUrl)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject('Something went wrong');
          if (e?.response?.status === 401) {
            let navigate = useNavigate();
            navigate('/');
          }
        });
    } catch (error) {
      reject(error);
      if (error?.response?.status === 401) {
        let navigate = useNavigate();
        navigate('/');
      }
    }
  });
}
export function validateRequired(value, message) {
  try {
    if (value.trim() == '' || value == undefined || value == null) {
      return message ? message : false;
    } else {
      return message ? '' : true;
    }
  } catch (error) {
    return '';
  }
}

export function sendRootPage(props) {
  props.navigation.reset({
    index: 0,
    routes: [{ name: 'home' }],
  });
}

export function logout(props) {
  props.navigation.reset({
    index: 0,
    routes: [{ name: 'login' }],
  });
}

/**********
 * Description:-
 * Search value in Array
 * Param:
 * 1.searchArray:Array need To be search
 * 2.searchValue:search value String
 * 3.objectArray:Field need to be search in searchArray array
 * Return Array as output
 ************/

/******* End SearchArray Function ***********/
export function checkForUndefined(inputStr) {
  if (
    inputStr == undefined ||
    inputStr == 'undefined' ||
    inputStr == null ||
    inputStr == 'null' ||
    inputStr == 'NULL' ||
    inputStr == 'NaN' ||
    inputStr == ''
  ) {
    return true;
  }
}

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];